const deliver = [
  {
    path: "/classLibrary",
    name: "classLibrary",
    component: (resolve) =>
      require(["@/components/deliver/classLibrary/classLibrary.vue"], resolve),
    meta: {
      title: "classLibrary",
      vis: false,
      type: "login",
      alias: "类库定义",
    },
  },
  {
    path: "/decompositionStructure",
    name: "decompositionStructure",
    component: (resolve) =>
      require([
        "@/components/deliver/classLibrary/decompositionStructure/index.vue",
      ], resolve),
    meta: {
      title: "decompositionStructure",
      vis: false,
      type: "login",
      alias: "分解结构",
    },
  },
  {
    path: "/organizationalManagement",
    name: "organizationalManagement",
    component: (resolve) =>
      require([
        "@/components/deliver/classLibrary/organizationalManagement/index.vue",
      ], resolve),
    meta: {
      title: "organizationalManagement",
      vis: false,
      type: "login",
      alias: "组织管理",
    },
  },
  {
    path: "/permissionManagement",
    name: "permissionManagement",
    component: (resolve) =>
      require([
        "@/components/deliver/classLibrary/permissionManagement/index.vue",
      ], resolve),
    meta: {
      title: "permissionManagement",
      vis: false,
      type: "login",
      alias: "权限管理",
    },
  },
  {
    path: "/deliver",
    name: "deliver",
    component: (resolve) =>
      require(["@/components/deliver/deliverData/index.vue"], resolve),
    meta: {
      title: "deliver",
      vis: true,
      type: "login",
      alias: "交付",
      icon: "el-icon-document-checked",
    },
  },
  {
    path: "/dataUpload",
    name: "dataUpload",
    component: (resolve) =>
      require([
        "@/components/deliver/newDeliverData/dataUpload/index.vue",
      ], resolve),
    meta: {
      title: "dataUpload",
      vis: false,
      type: "login",
      alias: "交付数据",
      icon: "el-icon-document-checked",
    },
  },
  {
    path: "/relatedRelationships",
    name: "relatedRelationships",
    component: (resolve) =>
      require([
        "@/components/deliver/newDeliverData/relatedRelationships/index.vue",
      ], resolve),
    meta: {
      title: "relatedRelationships",
      vis: false,
      type: "login",
      alias: "关联关系",
      icon: "el-icon-document-checked",
    },
  },
  {
    path: "/statisticalReport",
    name: "statisticalReport",
    component: (resolve) =>
      require([
        "@/components/deliver/newDeliverData/statisticalReport/index.vue",
      ], resolve),
    meta: {
      title: "statisticalReport",
      vis: false,
      type: "login",
      alias: "统计报表",
      icon: "el-icon-document-checked",
    },
  },
  {
    path: "/comprehensiveBrowsing",
    name: "comprehensiveBrowsing",
    component: (resolve) =>
      require([
        "@/components/deliver/dataBrowsing/comprehensiveBrowsing.vue",
      ], resolve),
    meta: {
      title: "comprehensiveBrowsing",
      vis: false,
      type: "login",
      alias: "综合浏览",
      icon: "el-icon-document-checked",
    },
  },
  {
    path: "/dataSearch",
    name: "dataSearch",
    component: (resolve) =>
      require(["@/components/deliver/dataBrowsing/dataSearch.vue"], resolve),
    meta: {
      title: "dataSearch",
      vis: false,
      type: "login",
      alias: "数据搜索",
      icon: "el-icon-document-checked",
    },
  },
];
export default [...deliver];



// WEBPACK FOOTER //
// ./src/router/routes/deliver.js